// This list of events should correspond with `stripe-webhook` python script `set-up-webhook-endpoint.py`
export var StripeEventType;
(function (StripeEventType) {
    StripeEventType["CustomerSubscriptionDeleted"] = "customer.subscription.deleted";
    StripeEventType["CustomerSubscriptionUpdated"] = "customer.subscription.updated";
    StripeEventType["CustomerSubscriptionPendingUpdateApplied"] = "customer.subscription.pending_update_applied";
    StripeEventType["InvoiceCreated"] = "invoice.created";
    StripeEventType["InvoicePaymentSucceeded"] = "invoice.payment_succeeded";
    StripeEventType["InvoicePaymentFailed"] = "invoice.payment_failed";
})(StripeEventType || (StripeEventType = {}));
//# sourceMappingURL=stripeEventType.js.map